import type { ConfigureApiFormDraft } from './ConfigureApiModal.types';

/**
 * Values for Rate Limit selects — same semantics as Digibee API Trigger (canvas) and connector jsonExample keys `limitBy` / `aggregateBy`.
 */

export const CONFIGURE_API_RATE_LIMIT_LIMIT_BY_OPTIONS = ['API'] as const;

/** Digibee docs: rate limit requires API Key or Basic Auth; gateway must expose External or Internal API. */
export type ConfigureApiRateLimitPrerequisiteSlice = Pick<
  ConfigureApiFormDraft,
  'keyAuth' | 'basicAuth' | 'externalApiEnabled' | 'internalApiEnabled'
>;

export function hasConfigureApiRateLimitPrerequisites(
  form: ConfigureApiRateLimitPrerequisiteSlice
): boolean {
  const hasCredentialAuth = Boolean(form.keyAuth || form.basicAuth);
  const apiExposed = Boolean(
    form.externalApiEnabled || form.internalApiEnabled
  );
  return hasCredentialAuth && apiExposed;
}

export const CONFIGURE_API_RATE_LIMIT_AGGREGATE_BY_OPTIONS = [
  'Consumer',
  'Credential (API Key, Basic Auth)'
] as const;
